/* X1 · the bottom tab bar's icons.
 *
 * Line icons drawn in `currentColor`, so the active tab's accent colours its
 * icon with no second set. They replace chess glyphs (♜ ♟), which had run out:
 * a tab for games and one for progress have no piece that means them.
 */
const PATHS = {
  learn: ["M2 4h6a4 4 0 0 1 4 4v13a3 3 0 0 0-3-3H2z", "M22 4h-6a4 4 0 0 0-4 4v13a3 3 0 0 1 3-3h7z"],
  play: ["M13 2 3 14h9l-1 8 10-12h-9l1-8z"],
  progress: ["M8 21h8", "M12 17v4", "M7 4h10v5a5 5 0 0 1-10 0z", "M17 5h3v2a3 3 0 0 1-3 3", "M7 5H4v2a3 3 0 0 0 3 3"],
  ledger: ["M3 21h18", "M6 17v-5", "M11 17V6", "M16 17v-8", "M20 17V3"],
};

export default function TabIcon({ name, size = 22 }) {
  return (
    <svg aria-hidden="true" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      {(PATHS[name] || []).map((d) => (
        <path key={d} d={d} />
      ))}
    </svg>
  );
}
